export type { M100RichTextProps } from './M100RichText';
export { M100RichText } from './M100RichText';
export { M100RichText as default } from './M100RichText';
